import { Role } from "../../Helpers/AuthorizationDataProvider";

export interface Props{
	onClose: () => void
}

export interface Feedback{
	description: string
	feedbackType: FeedbackTypes
	topics: string
	shortDescription: string
}

export enum FeedbackTypes {
	BugReport = 'BugReport',
	FlagOfAbuse = 'FlagOfAbuse',
	GeneralFeedback = 'GeneralFeedback',
	VideoFeedback = 'VideoFeedback'
}

export interface CreateFeedbackRequest{
	content1?: File
	content2?: File
	content3?: File
	content4?: File
	content5?: File
	description: string
	feedbackType: FeedbackTypes
	topics: string
	resourceReported?: string
	shortDescription: string
	userReported?: string
}

export interface User {
	firstName: string
	imageId: string
	lastName: string
	role: Role
	userId: string
}